import { EnvironmentProviders, inject, Provider, provideEnvironmentInitializer } from '@angular/core';
import { NavigationService } from './navigation.service';
import { NavigationLoaderService } from './navigation-loader.service';

export function provideNavigation(): Array<Provider | EnvironmentProviders> {
  return [
    provideEnvironmentInitializer(() => inject(NavigationService)),
    provideEnvironmentInitializer(() => inject(NavigationLoaderService))
  ];
}
